import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Flex,
} from "@chakra-ui/react";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
export const SetPageSizeModal = ({
  isOpen,
  onClose,
  input,
  isLocked,
  func,
}: any) => {
  const [state, setState] = useState(input);
  const [lock, setLock] = useState(isLocked);
  const handleClick = () => {
    func(state, lock);
    onClose();
  };
  return (
    <Modal size={"xs"} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Flex justifyContent={"space-between"}>
            <Input
              type="number"
              w={"25%"}
              mr={"5px"}
              value={state}
              onChange={(e: any) => setState(e.target.value)}
            />
            <Button
              bgColor="#327171"
              color={"white"}
              onClick={handleClick}
              w={"75%"}
            >
              Set no. of records
            </Button>
            {lock ? (
              <button
                style={{ backgroundColor: "white" }}
                type="button"
                onClick={() => {
                  setLock(false);
                  localStorage.removeItem("booking-list-pageSize-content");
                }}
              >
                <AiFillLock style={{ fontSize: "20px", color: "#308888" }} />
              </button>
            ) : (
              <button
                style={{ backgroundColor: "white" }}
                type="button"
                onClick={() => {
                  setLock(true);
                  localStorage.setItem(
                    "booking-list-pageSize-content",
                    state
                  );
                }}
              >
                <AiFillUnlock style={{ fontSize: "20px", color: "#308888" }} />
              </button>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
